<template>
  <div class="text-truncate">
    {{ data.value | summaryText }}
  </div>
</template>

<script>
import BaseCellType from './Base.vue'

export default {
  name: 'TextCellType',
  extends: BaseCellType,
}
</script>

<style scoped>

</style>
